// Slice-10 admin user index. Slice-11 SPA pass adds the per-row edit
// drawer + bulk archive UX; slice 10 is read-only listing only.

import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import type { components } from "../api/identity.gen";
import { useI18n } from "../i18n/I18nContext";

// See RolesScreen for the CursorPage<T> cast rationale (slice 12
// closeout fixes the OpenAPI schema to use a generic page envelope).
type UserDto = components["schemas"]["UserDto"];

export function UsersScreen(): JSX.Element {
  const { t } = useI18n();
  const query = useQuery({
    queryKey: ["users", "index"],
    queryFn: async () => {
      const response = await apiClient.GET("/identity/users", {
        params: { query: { limit: 50 } },
      });
      if (!response.data) {
        throw new Error("users_fetch_failed");
      }
      return response.data;
    },
  });

  return (
    <div>
      <h1>{t("users.heading")}</h1>
      {query.isLoading && <p>{t("login.discovering")}</p>}
      {query.isError && (
        <p role="alert" style={{ color: "var(--rc-color-danger)" }}>
          {(query.error as Error).message}
        </p>
      )}
      {query.data && query.data.items.length === 0 && <p>{t("users.empty")}</p>}
      {query.data && query.data.items.length > 0 && (
        <table className="rc-table">
          <thead>
            <tr>
              <th>{t("users.column.username")}</th>
              <th>{t("users.column.displayName")}</th>
              <th>{t("users.column.email")}</th>
              <th>{t("users.column.disabled")}</th>
            </tr>
          </thead>
          <tbody>
            {(query.data.items as unknown as UserDto[]).map((u) => (
              <tr key={u.user_id}>
                <td><code>{u.username}</code></td>
                <td>{u.display_name}</td>
                <td>{u.email}</td>
                <td>{u.is_disabled ? "✔︎" : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
